// document.addEventListener(window.visibilityChange, playPauseGame, false);

import {madnes_set_audio_volume} from "../framework/src/engine/madnes/madnes_audio";
import {MadnesInterface} from "./libs/mi/MadnesInterface";
import {ServerCfg} from "./ServerCfg";
import {Game} from "./game/Game";
import {GameInfo} from "./game/GameInfo";
import {GameConfig} from "./game/GameConfig"
import {SymbolsManager} from "./symbol/SymbolsManager";
import {GameAssets} from "./game/GameAssets";
import {ReelPrinter} from "./reel/ReelPrinter";
import {SpinReels} from "./reel/SpinReels";
import {Preinfo} from "./preinfo/Preinfo";
import { behavior_config } from "../framework/src/engine/madnes/madnes_variables";

var gameReady = false;

/** @type MadnesInterface  */
export var MI = new MadnesInterface();
MI.init();

/** @type {ServerCfg} */
var serverConfig = new ServerCfg();

var game = new Game();

/** @type {Preinfo} */
var preinfo;
//game.ready = false;

export var gameInfo = new GameInfo();
var gameConfig = new GameConfig();
var symbolsManager = new SymbolsManager();

//gameConfig.showPreinfo = true;

// function playPauseGame()
// {
// 	if(main_phaser) {
//
// 		if(document[hiddenName]) {
// 			main_phaser.paused = true;
// 		} else {
// 			main_phaser.paused = false;
// 		}
// 	}
// }

/**
 * @param {string} dname
 * @param {Object=} config
 * @param {number=} ver
 */
function init_game(dname, config, ver) {

	// if(typeof ver === 'undefined') {
	// 	ver = 1;
	// }

	// madnes_add_fontface_preload("font_TeXGyrePagella");
	//
	// last_round_autostart_enabled = !gameConfig.showPreinfo;
	//
	// MI.setTextureVersion(ver);
	// MI.setNativeScreenSize(1280, 720);

	// madnes_config_load_symbols = false;

	//madnes_set_languages(['en', 'cs', 'sk']);
	// madnes_set_def_lang('en');
	// madnes_load_init("vikings", config);
	//
	// delete to_load_fonts_madnes["win_font"];
	// delete to_load_madnes["coin_sprite"];
	// delete to_load_madnes["win_font_bg"];
	//
	// for(var i in to_load) {
	// 	madnes_add_to_load(i, to_load[i]);
	// }

	//delete to_load_madnes['coin_sprite'];
	//delete to_load_madnes['win_font_bg'];

	// for(var i in to_load_json_atlas) {
	// 	madnes_add_json_atlas_to_load(i, to_load_json_atlas[i][0], to_load_json_atlas[i][1]);
	// }
	//
	// for(var i in to_load_spritesheets) {
	// 	madnes_add_spritesheet_to_load(i, to_load_spritesheets[i]['url'], to_load_spritesheets[i]['w'], to_load_spritesheets[i]['h']);
	// }
	//
	// for(var i in to_load_fonts) {
	// 	madnes_add_font_to_load(i, to_load_fonts[i]);
	// }
	//
	// for(var i in to_load_json)
	// {
	// 	if(infotexts_languages.indexOf(lang) === -1)
	// 	{
	// 		to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
	// 	}
	//
	// 	madnes_add_json(i, to_load_json[i]);
	// }
	//
	// for(var i in to_load_audio)
	// {
	// 	madnes_add_audio(i, to_load_audio[i]);
	// }

	//madnes_set_load_complete_function(ctrl_init_bonus);

	// madnes_set_printdesk_function(init_desk);
	// madnes_set_updatedesk_function(function() {});

	// madnes_set_rotate_function(rotateRun);

	// madnes_set_infomenu_init_function(infomenuInit);
	// madnes_set_infomenu_update_function(infomenuUpdate);
	// madnes_set_infomenu_open_function(infomenuOpen);
	// madnes_set_infomenu_close_function(infomenuClose);
	// madnes_set_infomenu_left_function(infomenuLeft);
	// madnes_set_infomenu_right_function(infomenuRight);
	//
	// madnes_set_on_rotate_release(rotateRelease);
	// madnes_set_on_forcestop_press(forcestopPress);
	//
	// madnes_set_preinfo_close_function(preinfoClose);
	//
	// madnes_set_game_ready_function(function() {
	// 	//game.ready = true;
	// 	if(is_last_round_autostart() && !game.inPreinfo) {
	// 		madnes_rotate_start();
	// 	}
	// });

	/*
	madnes_set_betmenu_choose_function(betmenu_choose);
	madnes_set_betmenu_open_function(betmenu_open);
	madnes_set_on_key_down_function(ctrl_on_key_down);
	*/

	// madnes_set_coin_values_init(function(currency)
	// {
	// 	if(currency === "PLN")
	// 	{
	// 		coin_values = [0.1, 1];
	// 	}
	// 	else
	// 	{
	// 		madnes_coin_values_init(currency);
	// 	}
	// });

//	madnes_set_bets_init(function(currency)
//	{
//		if(currency === "PLN")
//		{
//			bets = [10];
//		}
//	});

	// madnes_init(dname);
}
window["init_game"] = init_game;


export function vk_init_desk() {

	// madnes_game_title = "Vikings";

	var gameAssets = new GameAssets(gameConfig);

	serverConfig.setServerConfig(MI.server.getConfig());

	// MI.setBigWinFactors(
	// 	serverConfig.getMinBigWinFactor(),
	// 	serverConfig.getMinMegaWinFactor(),
	// 	serverConfig.getMinSuperMegaWinFactor()
	// );

	/*if(serverConfig.getBetSet()) {
		//madnes_init_bets(serverConfig.getBetSet());
	}*/

	serverConfig._serverConfig.behavior = behavior_config
	vk_configSounds(serverConfig, gameConfig);

	createGame(gameAssets);

	if(gameConfig.showPreinfo) {
		createPreinfo();
	} else {
		preinfo = null;
	}
}

/** @param {GameAssets} gameAssets */
function createGame(gameAssets) {

	gameAssets.createPreloads();

	gameAssets.createReelsBg();
	gameAssets.createSea();
	gameAssets.createClouds();

	var reelPrinter = new ReelPrinter(gameConfig);

	var spinReels = new SpinReels();

	spinReels.init(reelPrinter, gameConfig, serverConfig, symbolsManager);

	game.init(spinReels, gameConfig, reelPrinter, serverConfig, symbolsManager, gameAssets);

	gameAssets.createStormGroup();

	game.spinReels.setSymbolsGroup(MI.addGroup("group_symbols"));
	game.spinReels.createBlackScreen();

	game.spinReels.setServerReels(serverConfig.getReels());
	game.spinReels.createReels();

	gameAssets.createReelCover1();
	gameAssets.createRopes();
	gameAssets.createFireRopes();

	game.spinReels.animsSymbolsGroup = MI.addGroup("group_anims_symbols");
	game.spinReels.arrowsSymbolsGroup = MI.addGroup("group_arrows_symbols");

	gameAssets.createFsGroup();

	gameAssets.createReelCover2();
	gameAssets.createNodes();

	game.createHeader();

	gameAssets.createWinViewer();
}

function rotateRelease() {
	game.spinReleased();
}

function forcestopPress() {
	game.forcestopPressed();
}

function createPreinfo() {

	hibernateGame();

	// inpreinfo = true;

	preinfo = new Preinfo();
	preinfo.create();
};

export function preinfoClose() {

	// inpreinfo = false;
	preinfo.close();
	preinfo = null;

	reviveGame();

	// last_round_autostart_enabled = true;
	// if(is_last_round_autostart()) {
	// 	madnes_rotate_start();
	// }
}

function hibernateGame() {
	game.spinReels.killAllSymbols();

	game.assets.stopClouds();
	game.assets.killClouds();
	game.assets.hideSea();
	game.assets.killPreloads();
	game.assets.bg.kill();
	game.assets.visibleReelCover(false);
}

function reviveGame() {
	game.spinReels.reviveAllSymbols();
	game.spinReels.hideInvisibleSymbols();

	game.assets.reviveClouds();
	game.assets.playClouds();
	game.assets.showSea();
	game.assets.revivePreloads();
	game.assets.bg.revive();
	game.assets.visibleReelCover(true);
}

export function infomenuInit() {
	gameInfo.init(serverConfig, symbolsManager);
	gameInfo.create();
	//gameInfo.close();
}

export function infomenuUpdate() {
	gameInfo.update(MI.getBet());
}

export function infomenuOpen() {

	// hibernateGame();

	gameInfo.update(MI.getBet());
	gameInfo.open();
}

export function infomenuClose() {

	// reviveGame();

	gameInfo.close();
	// gameInfo.destroy();
}

export function infomenuLeft() {
	gameInfo.slideLeft();
}

export function infomenuRight() {
	gameInfo.slideRight();
}

export function infomenuHome() {
	gameInfo.showMain();
}

export function rotateRun() {
	game.spinStart();
}

/**
 * @param {ServerCfg} serverConfig
 * @param {GameConfig} gameConfig
 */
function vk_configSounds(serverConfig, gameConfig) {
	var vol = 1;

	vol = serverConfig.getVolumeBigWin();
	madnes_set_audio_volume('bwin_BigWin', vol);
	madnes_set_audio_volume('bwin_Money', vol);
	madnes_set_audio_volume('bwin_BigWin_Thunder', vol);
	madnes_set_audio_volume('bwin_BigWin_Counter', vol);
	madnes_set_audio_volume('bwin_FreeSpins', vol);


	vol = serverConfig.getVolumeButtonEffect();
	madnes_set_audio_volume('button_click', vol);

//	vol = serverConfig.getVolumeSpin();

	vol = serverConfig.getVolumeStartReel();
	madnes_set_audio_volume("reel_Start_1", vol);
	madnes_set_audio_volume("reel_Start_2", vol);
	madnes_set_audio_volume("reel_Start_3", vol);
	gameConfig.reelStartInitSound = vol;

	vol = serverConfig.getVolumeStopReel();
	madnes_set_audio_volume("reel_Stop", vol);
	gameConfig.reelStopInitSound = vol;

	vol = serverConfig.getVolumeWinAnim();
	madnes_set_audio_volume("win_Axe", vol);
	madnes_set_audio_volume("win_Bracelet", vol);
	madnes_set_audio_volume("win_Helmet", vol);
	madnes_set_audio_volume("win_Letter", vol);
	madnes_set_audio_volume("win_Shield", vol);
	madnes_set_audio_volume("win_Ship", vol);
	madnes_set_audio_volume("win_Viking", vol);
	madnes_set_audio_volume("win_Woman", vol);
	madnes_set_audio_volume("win_Multiplier_Axe", vol);
	madnes_set_audio_volume("win_Multiplier_Bracelet", vol);
	madnes_set_audio_volume("win_Multiplier_Helmet", vol);
	madnes_set_audio_volume("win_Multiplier_Letter", vol);
	madnes_set_audio_volume("win_Multiplier_Shield", vol);
	madnes_set_audio_volume("win_Multiplier_Viking", vol);
	madnes_set_audio_volume("win_Multiplier_Woman", vol);
	madnes_set_audio_volume("bwin_Money_Short", vol);

	vol = serverConfig.getVolumeWinCounter();
	madnes_set_audio_volume("remittance_A", vol);
	madnes_set_audio_volume("remittance_B", vol);
	madnes_set_audio_volume("bonus_FreeSpins_Counter", vol);

	vol = serverConfig.getVolumeBackground();
	madnes_set_audio_volume("bg_Ambient", vol);
	madnes_set_audio_volume("bg_Music", vol);

	vol = serverConfig.getVolumeFSBackground();
	madnes_set_audio_volume("bg_FreeSpins_Loop", vol);
	madnes_set_audio_volume("bg_FreeSpins_Start", vol);

//	vol = serverConfig.getVolumeBonusBackground();

	vol = serverConfig.getVolumeMiscSound1();
	madnes_set_audio_volume("symbol_Ship_1", vol);
	madnes_set_audio_volume("symbol_Ship_2", vol);
	madnes_set_audio_volume("symbol_Ship_3", vol);
	madnes_set_audio_volume("reel_Search_Long", vol);
	madnes_set_audio_volume("reel_Search_Short", vol);

	vol = serverConfig.getVolumeMiscSound2();
	madnes_set_audio_volume("bonus_Arrow_1", vol);
	madnes_set_audio_volume("bonus_Arrow_2", vol);
	madnes_set_audio_volume("bonus_Lock_Fire", vol);

	vol = serverConfig.getVolumeMiscSound3();
	madnes_set_audio_volume("misc_Coin_Drop_1", vol);
	madnes_set_audio_volume("misc_Coin_Drop_2", vol);
	madnes_set_audio_volume("misc_Coin_Drop_3", vol);
	madnes_set_audio_volume("misc_Coin_Drop_4", vol);
	madnes_set_audio_volume("misc_Coin_Drop_5", vol);

	vol = serverConfig.getVolumeMiscSound4();
	madnes_set_audio_volume("bonus_FreeSpins_In", vol);

//	vol = serverConfig.getVolumeMiscSound5();
}